import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import * as Bridge from '@/api/BridgeApi'
import * as Layer from '@/components/common/layer'
import {
  BILL_PAYMENT_ROUTES,
  ENTRY_ROUTE_QUERY,
  SCHEDULE_PAYMENT_ROUTES,
  STATUS_CODE,
  TOP_NATIVE_ROUTES,
} from '@/domains/CommonDomain'
import { useTrans } from '@/hooks/useTrans'
import { cmodeValue } from '@/index'
import { IRootState } from '@/modules'
import { ERROR, errorActions, IErrorState } from '@/modules/common/error'
import { billPaymentMainSelector } from '@/modules/version/V2/bill-payment/BillPaymentMainModule'
import { push, redirect, reload } from '@/utils/historyUtils'

export const ErrorSection = () => {
  const $ = useTrans()
  const dispatch = useDispatch()
  const { errorCode, errorMessage } = useSelector<IRootState, IErrorState>(state => state[ERROR])
  const versionInfo = useSelector<IRootState>(state =>
    billPaymentMainSelector.getversioninfo(state),
  )

  const closeError = useCallback(() => {
    dispatch(errorActions.resolve())
  }, [dispatch])
  const moveToBillTop = useCallback(() => {
    dispatch(errorActions.resolve())
    //Bridge.navigateTo(TOP_NATIVE_ROUTES.WEBROOT)
    push(
      `${BILL_PAYMENT_ROUTES.ROOT}?${ENTRY_ROUTE_QUERY}&${versionInfo}&${
        cmodeValue === null ? 'cmode=1' : 'cmode=' + cmodeValue
      }`,
    )
  }, [dispatch, versionInfo])
  const moveToTop = useCallback(() => {
    dispatch(errorActions.resolve())
    Bridge.navigateTo(TOP_NATIVE_ROUTES.ROOT)
  }, [dispatch])
  const reloadPage = useCallback(() => {
    dispatch(errorActions.resolve())
    reload()
  }, [dispatch])

  const OkButton = () => {
    return (
      <Layer.Button onClick={closeError} is1Color>
        {$('common_ok_button')}
      </Layer.Button>
    )
  }

  const OkButtonGoBill = () => {
    return (
      <Layer.Button onClick={moveToBillTop} is1Color>
        {$('common_ok_button')}
      </Layer.Button>
    )
  }
  const MoveToTopButton = () => {
    return (
      <Layer.Button onClick={moveToTop} is1Color>
        {$('common_ok_button')}
      </Layer.Button>
    )
  }
  const ReloadButton = () => {
    return (
      <Layer.Button onClick={reloadPage} is1Color>
        {$('common_ok_button')}
      </Layer.Button>
    )
  }
  const RedirectPageButton = (props: { targetUrl: string; buttonContent: string }) => {
    const { targetUrl, buttonContent } = props
    const onClick = () => {
      closeError()
      redirect(targetUrl)
    }

    return <Layer.Button onClick={onClick}>{buttonContent}</Layer.Button>
  }

  const { buttons, code, message } = (function() {
    switch (errorCode) {
      case STATUS_CODE.INVALID_PARAMETER:
      case STATUS_CODE.HLI_BUSINESS_ERROR:
        return {
          buttons: [OkButton],
          code: <Layer.Code>({errorCode})</Layer.Code>,
          message: errorMessage,
        }
      case STATUS_CODE.NETWORK_TIMEOUT_ERROR:
      case STATUS_CODE.NETWORK_OFF:
        return {
          buttons: [ReloadButton],
          code: <></>,
          message: $('common_error_network_desc'),
        }
      case STATUS_CODE.UNKNOWN_SERVER_ERROR:
        return {
          buttons: [MoveToTopButton],
          code: <></>,
          message: $('common_error_server_desc'),
        }
      case STATUS_CODE.NO_DATA:
        return {
          buttons: [OkButton],
          code: <></>,
          message: $('common_error_nouserdata_desc'),
        }
      case STATUS_CODE.LOADING_FAILED:
        return {
          buttons: [OkButton],
          code: <></>,
          message: $('common_error_unknown_desc'),
        }
      case STATUS_CODE.NOTAVAILABLE_ACCOUNT:
        return {
          buttons: [OkButtonGoBill],
          code: <></>,
          message: errorMessage,
        }
      case STATUS_CODE.NO_SCHED_TRNS_DATA:
        return {
          buttons: [
            () => (
              <RedirectPageButton
                targetUrl={SCHEDULE_PAYMENT_ROUTES.ROOT}
                buttonContent={$('common_ok_button')}
              />
            ),
          ],
          code: <Layer.Code>({errorCode})</Layer.Code>,
          message: $('common_error_noschedtrnsdata_desc'),
        }
      case STATUS_CODE.EXIPIED_TOKEN:
      default:
        return {
          buttons: [MoveToTopButton],
          code: <Layer.Code>({errorCode})</Layer.Code>,
          message: errorMessage,
        }
    }
  })()

  return (
    <Layer.Wrapper isOpen={errorCode !== ''} close={closeError}>
      <Layer.Leave>
        <Layer.Message>{message}</Layer.Message>
        {code}
        <Layer.ButtonBox>
          {buttons.map((Button, index) => (
            <Button key={index} />
          ))}
        </Layer.ButtonBox>
      </Layer.Leave>
    </Layer.Wrapper>
  )
}
